import { render } from "./ProductSelectionBrandsSelectionItemBadges.vue?vue&type=template&id=d1ca6d06&scoped=true&ts=true"
import script from "./ProductSelectionBrandsSelectionItemBadges.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionBrandsSelectionItemBadges.vue?vue&type=script&lang=ts"

import "./ProductSelectionBrandsSelectionItemBadges.vue?vue&type=style&index=0&id=d1ca6d06&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ca6d06"]])

export default __exports__